export default {
    namespaced: true,
    state: {
        inviteParams: null,
    },
    getters: {
        hasInviteParams: (state) => {
            const p = state.inviteParams;
            return !!(p && p.p && p.e && p.s && (p.rn || p.ro));
        },
    },
    actions: {
        setInviteParams({ commit }, params) {
            commit('setInviteParams', params);
        },
        clearInviteParams({ commit }) {
            commit('setInviteParams', null);
        },
    },
    mutations: {
        setInviteParams(state, params) {
            state.inviteParams = params;
        },
    },
};
